import { useRef } from "react";
import styles from "./index.module.scss";
import cn from "classnames";
import { AnimatePresence } from "framer-motion";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@store";
import { setSubTabNum } from "@store/minersSelect/actions";
import useMediaQuery from "@utils/hooks/utils";
import useClickOutside from "@utils/hooks/useClickOutside";
import MinersSubTab from "./MinersSubTab";


interface MinerTableSubTabsPropsI {
  className?: string;
}

const useControl = (props: MinerTableSubTabsPropsI) => {
  const curTabNum = useSelector((root: RootState) => root.minersSelect.subtab);
  const tabs = useSelector((root: RootState) => root.minersSelect.subTabs);
  const [hideOthers, setHideOthers] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery("max", 768);
  const selectorRef = useRef<HTMLDivElement | null>(null);

  useClickOutside(() => {
    setTimeout(() => setOpen(false), 500);
  }, selectorRef.current || undefined);

  const setCurTabNum = (id: number) => {
    dispatch(setSubTabNum(id));
  }

  return {
    tabs,
    isOpen,
    curTabNum,
    hideOthers,
    isMobile,
    selectorRef,
    get curTab() { return curTabNum !== undefined ? tabs[curTabNum] : tabs[0] },

    hide() {  setOpen(false) },
    toggleOpen() { setOpen(x => !x) },
    setCurTabNum,
    setHideOthers,
  }
}

export default function MinersTableSubTabs(props: MinerTableSubTabsPropsI) {
  const ctrl = useControl(props);
  return (
    <div className={styles.tabs_container}>
      <div className={styles.settings_wrapper}>
        <div className={cn(styles.dropdown)} ref={ctrl.selectorRef}>
          { !!ctrl.curTab &&
            <MinersSubTab 
              setTab={() => ctrl.setCurTabNum(ctrl.curTabNum!)} 
              thisID={ctrl.curTabNum!} 
              currentID={ctrl.curTabNum!} 
              tabName={ctrl.curTab!.search[0]} 
              title={ctrl.curTab!.search.join(" ")}
              key={ctrl.curTabNum!}
              onClick={ctrl.toggleOpen}
              color={ctrl.curTab!.color}
            />
          }
          <div className={cn(styles.opener, {[styles.open]: ctrl.isOpen})}/>
        </div>
        <div className={cn(styles.btns_wrapper, {[styles.hidden]: !ctrl.isOpen})}>
          <AnimatePresence initial={false}>
            { ctrl.tabs.map((desc, i) =>
              <MinersSubTab
                setTab={() => ctrl.setCurTabNum(i)} 
                thisID={i} 
                currentID={ctrl.curTabNum ?? 0} 
                tabName={desc.search.join(" ")} 
                key={i}
                hasItems={true}
                color={desc.color}
                last={i === ctrl.tabs.length - 1}
                skippable
              />)
            }
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
}
